"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCall;

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _utils = require("./modules/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var functionName = 'createCall';

var isCallbackCall = function isCallbackCall(args) {
  if (args.length < 2) return false;
  if (typeof args[args.length - 1] === 'function') return true;
  return false;
};

var hasCallee = function hasCallee(args) {
  if (typeof args[0] !== 'function') return false;
  return true;
};

function createCall(context, initState) {
  if (!(0, _isPlainObject2["default"])(context)) {
    throw new Error("\n        ".concat(functionName, " expected context argument to be a plain object but\n        instead received an object with type ").concat((0, _utils.typeofOrNull)(context), ".\n        the best way to supply a valid context is to use the createContext\n        function provided by this library.\n      "));
  } // set error as default level in absence of specified level by context


  _loglevel["default"].setDefaultLevel(context.logLevel || 'error'); // expose log level setting function


  typeof window !== 'undefined' && (window.setLogLevel = function (level) {
    return _loglevel["default"].setLevel(level);
  });
  var privateContext = context;
  var privateState = initState || Object.freeze({});
  var privateMock = null;
  var globalApiCallbacks = {};

  var call = function call() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (privateMock) return privateMock.apply(void 0, args);
    if (!hasCallee(args)) return call;
    var client = {
      context: privateContext,
      getState: getState,
      replaceState: replaceState,
      setState: setState,
      globalApiCallbacks: globalApiCallbacks
    };

    if (isCallbackCall(args)) {
      _utils.callWithCallback.apply(void 0, [client].concat(args));

      return;
    }

    return _utils.callWithPromise.apply(void 0, [client].concat(args));
  }; // hard set state, called internally in api client


  var replaceState = function replaceState(newStateOrReplacer) {
    var replacer = typeof newStateOrReplacer === 'function' ? newStateOrReplacer : _newStateReplacer(newStateOrReplacer);
    var currentState = privateState;
    var nextState = replacer(currentState);

    _loglevel["default"].debug('[API-CLIENT] State Replace\nprev state:', currentState, '\nnew State:', nextState);

    privateState = nextState;
    notifyStateListeners(nextState, currentState);
  };

  var _newStateReplacer = function _newStateReplacer(newState) {
    return function (_) {
      return newState;
    };
  }; // merge state without notification, typically called externally by consuming app


  var setState = function setState(partialState) {
    var newState = _objectSpread({}, privateState, {}, partialState);

    _loglevel["default"].debug('[API-CLIENT] State Set\nprev state:', privateState, '\nnew State:', newState);

    privateState = newState;
  };

  var getState = function getState() {
    return privateState;
  };

  var mock = function mock(mockCall) {
    if (typeof mockCall !== 'function') {
      throw new Error("\n        mock expected the only argument to be a function but\n        instead received an object with type ".concat((0, _utils.typeofOrNull)(mockCall), ".\n      "));
    }

    privateMock = mockCall;
  };

  var unmock = function unmock() {
    privateMock = null;
  };

  call.replaceContext = function (context) {
    privateContext = context;
  };

  call.getContext = function () {
    return privateContext;
  };

  call.replaceState = replaceState;
  call.setState = setState;
  call.getState = getState;
  call.mock = mock;
  call.unmock = unmock;

  call.setOnRequest = function (onRequest) {
    globalApiCallbacks = _objectSpread({}, globalApiCallbacks, {
      onRequest: onRequest
    });
  };

  call.setOnResponse = function (onResponse) {
    globalApiCallbacks = _objectSpread({}, globalApiCallbacks, {
      onResponse: onResponse
    });
  };

  var stateListeners = [];

  var makeRemoveStateListener = function makeRemoveStateListener(cb) {
    return function () {
      stateListeners = stateListeners.filter(function (l) {
        return l !== cb;
      });
    };
  };

  call.onStateUpdated = function (cb) {
    stateListeners.push(cb);
    return makeRemoveStateListener(cb);
  };

  var notifyStateListeners = function notifyStateListeners(nextState, prevState) {
    return stateListeners.forEach(function (cb) {
      return cb(nextState, prevState);
    });
  };

  return call;
}